import { defaultColours } from "./DefaultColours";

export const overviewScoreSquares = [
	{
		type: "shape",
		x: {
			value: 0.0,
			unit: "POINT"
		},
		y: {
			value: 0.0,
			unit: "POINT"
		},
		width: {
			value: 15.0,
			unit: "POINT"
		},
		height: {
			value: 15.0,
			unit: "POINT"
		},
		absolutePosition: false,
		condition: {
			type: "function",
			function: "eq",
			arguments: [
				{
					type: "field",
					jsonPath: "#.score"
				},
				{
					type: "function",
					function: "int",
					arguments: [
						{
							type: "static",
							text: "1"
						}
					]
				}
			]
		},
		loop: null,
		filter: null,
		shape: "SQUARE",
		fillColor: defaultColours[0]
	},
	{
		type: "shape",
		x: {
			value: 0.0,
			unit: "POINT"
		},
		y: {
			value: 0.0,
			unit: "POINT"
		},
		width: {
			value: 15.0,
			unit: "POINT"
		},
		height: {
			value: 15.0,
			unit: "POINT"
		},
		absolutePosition: false,
		condition: {
			type: "function",
			function: "eq",
			arguments: [
				{
					type: "field",
					jsonPath: "#.score"
				},
				{
					type: "function",
					function: "int",
					arguments: [
						{
							type: "function",
							function: "+",
							arguments: [
								{
									type: "function",
									function: "int",
									arguments: [
										{
											type: "static",
											text: "1"
										}
									]
								},
								{
									type: "static",
									text: "1"
								}
							]
						}
					]
				}
			]
		},
		loop: null,
		filter: null,
		shape: "SQUARE",
		fillColor: defaultColours[1]
	},
	{
		type: "shape",
		x: {
			value: 0.0,
			unit: "POINT"
		},
		y: {
			value: 0.0,
			unit: "POINT"
		},
		width: {
			value: 15.0,
			unit: "POINT"
		},
		height: {
			value: 15.0,
			unit: "POINT"
		},
		absolutePosition: false,
		condition: {
			type: "function",
			function: "eq",
			arguments: [
				{
					type: "field",
					jsonPath: "#.score"
				},
				{
					type: "function",
					function: "int",
					arguments: [
						{
							type: "function",
							function: "+",
							arguments: [
								{
									type: "function",
									function: "int",
									arguments: [
										{
											type: "static",
											text: "1"
										}
									]
								},
								{
									type: "static",
									text: "2"
								}
							]
						}
					]
				}
			]
		},
		loop: null,
		filter: null,
		shape: "SQUARE",
		fillColor: defaultColours[2]
	},
	{
		type: "shape",
		x: {
			value: 0.0,
			unit: "POINT"
		},
		y: {
			value: 0.0,
			unit: "POINT"
		},
		width: {
			value: 15.0,
			unit: "POINT"
		},
		height: {
			value: 15.0,
			unit: "POINT"
		},
		absolutePosition: false,
		condition: {
			type: "function",
			function: "eq",
			arguments: [
				{
					type: "field",
					jsonPath: "#.score"
				},
				{
					type: "function",
					function: "int",
					arguments: [
						{
							type: "function",
							function: "+",
							arguments: [
								{
									type: "function",
									function: "int",
									arguments: [
										{
											type: "static",
											text: "1"
										}
									]
								},
								{
									type: "static",
									text: "3"
								}
							]
						}
					]
				}
			]
		},
		loop: null,
		filter: null,
		shape: "SQUARE",
		fillColor: defaultColours[3]
	},
	{
		type: "shape",
		x: {
			value: 0.0,
			unit: "POINT"
		},
		y: {
			value: 0.0,
			unit: "POINT"
		},
		width: {
			value: 15.0,
			unit: "POINT"
		},
		height: {
			value: 15.0,
			unit: "POINT"
		},
		absolutePosition: false,
		condition: {
			type: "function",
			function: "eq",
			arguments: [
				{
					type: "field",
					jsonPath: "#.score"
				},
				{
					type: "function",
					function: "int",
					arguments: [
						{
							type: "function",
							function: "+",
							arguments: [
								{
									type: "function",
									function: "int",
									arguments: [
										{
											type: "static",
											text: "1"
										}
									]
								},
								{
									type: "static",
									text: "4"
								}
							]
						}
					]
				}
			]
		},
		loop: null,
		filter: null,
		shape: "SQUARE",
		fillColor: defaultColours[4]
	},
	{
		type: "shape",
		x: {
			value: 0.0,
			unit: "POINT"
		},
		y: {
			value: 0.0,
			unit: "POINT"
		},
		width: {
			value: 15.0,
			unit: "POINT"
		},
		height: {
			value: 15.0,
			unit: "POINT"
		},
		absolutePosition: false,
		condition: {
			type: "function",
			function: "eq",
			arguments: [
				{
					type: "field",
					jsonPath: "#.score"
				},
				{
					type: "function",
					function: "int",
					arguments: [
						{
							type: "function",
							function: "+",
							arguments: [
								{
									type: "function",
									function: "int",
									arguments: [
										{
											type: "static",
											text: "1"
										}
									]
								},
								{
									type: "static",
									text: "5"
								}
							]
						}
					]
				}
			]
		},
		loop: null,
		filter: null,
		shape: "SQUARE",
		fillColor: defaultColours[5]
	},
	{
		type: "shape",
		x: {
			value: 0.0,
			unit: "POINT"
		},
		y: {
			value: 0.0,
			unit: "POINT"
		},
		width: {
			value: 15.0,
			unit: "POINT"
		},
		height: {
			value: 15.0,
			unit: "POINT"
		},
		absolutePosition: false,
		condition: {
			type: "function",
			function: "eq",
			arguments: [
				{
					type: "field",
					jsonPath: "#.score"
				},
				{
					type: "function",
					function: "int",
					arguments: [
						{
							type: "function",
							function: "+",
							arguments: [
								{
									type: "function",
									function: "int",
									arguments: [
										{
											type: "static",
											text: "1"
										}
									]
								},
								{
									type: "static",
									text: "6"
								}
							]
						}
					]
				}
			]
		},
		loop: null,
		filter: null,
		shape: "SQUARE",
		fillColor: defaultColours[6]
	},
	{
		type: "shape",
		x: {
			value: 0.0,
			unit: "POINT"
		},
		y: {
			value: 0.0,
			unit: "POINT"
		},
		width: {
			value: 15.0,
			unit: "POINT"
		},
		height: {
			value: 15.0,
			unit: "POINT"
		},
		absolutePosition: false,
		condition: {
			type: "function",
			function: "eq",
			arguments: [
				{
					type: "field",
					jsonPath: "#.score"
				},
				{
					type: "function",
					function: "int",
					arguments: [
						{
							type: "function",
							function: "+",
							arguments: [
								{
									type: "function",
									function: "int",
									arguments: [
										{
											type: "static",
											text: "1"
										}
									]
								},
								{
									type: "static",
									text: "7"
								}
							]
						}
					]
				}
			]
		},
		loop: null,
		filter: null,
		shape: "SQUARE",
		fillColor: defaultColours[7]
	},
	{
		type: "shape",
		x: {
			value: 0.0,
			unit: "POINT"
		},
		y: {
			value: 0.0,
			unit: "POINT"
		},
		width: {
			value: 15.0,
			unit: "POINT"
		},
		height: {
			value: 15.0,
			unit: "POINT"
		},
		absolutePosition: false,
		condition: {
			type: "function",
			function: "eq",
			arguments: [
				{
					type: "field",
					jsonPath: "#.score"
				},
				{
					type: "function",
					function: "int",
					arguments: [
						{
							type: "function",
							function: "+",
							arguments: [
								{
									type: "function",
									function: "int",
									arguments: [
										{
											type: "static",
											text: "1"
										}
									]
								},
								{
									type: "static",
									text: "8"
								}
							]
						}
					]
				}
			]
		},
		loop: null,
		filter: null,
		shape: "SQUARE",
		fillColor: defaultColours[8]
	},
	{
		type: "shape",
		x: {
			value: 0.0,
			unit: "POINT"
		},
		y: {
			value: 0.0,
			unit: "POINT"
		},
		width: {
			value: 15.0,
			unit: "POINT"
		},
		height: {
			value: 15.0,
			unit: "POINT"
		},
		absolutePosition: false,
		condition: {
			type: "function",
			function: "eq",
			arguments: [
				{
					type: "field",
					jsonPath: "#.score"
				},
				{
					type: "function",
					function: "int",
					arguments: [
						{
							type: "function",
							function: "+",
							arguments: [
								{
									type: "function",
									function: "int",
									arguments: [
										{
											type: "static",
											text: "1"
										}
									]
								},
								{
									type: "static",
									text: "9"
								}
							]
						}
					]
				}
			]
		},
		loop: null,
		filter: null,
		shape: "SQUARE",
		fillColor: defaultColours[9]
	}
];
